var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"news-detail"},[_c('div',{staticClass:"news-detail-title"},[_vm._v(_vm._s(_vm.data.title))]),_vm._v(" "),_c('div',{staticClass:"news-detail-time"},[_vm._v(_vm._s(_vm.data.create_time))]),_vm._v(" "),_c('div',{staticClass:"news-detail-content",domProps:{"innerHTML":_vm._s(_vm.data.content)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1da0a661","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/news/detail.vue
// module id = null
// module chunks = 